export default __webpack_public_path__ + "static/media/boxtype4.7d75fdfc.JPG";